export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  const addVideoTag = true;

  $widget.append('<iframe></iframe>');
  $widget.wrap('<div id="videoSection"></div>');

  $widget.videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,

    videoWidgetLoaded: function (data) {
      if (data.Slides.length >= 1 && addVideoTag) {
        $('#videoSection').append(`<div class="video-tag"></div`);
      } else {
        $('.video-container').remove();
      }
    },
  });
}
